import React from "react";

function SvgIcMapPoi129(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M15.98 12.286a3 3 0 11-.001-6 3 3 0 010 6zm0 6.714a3 3 0 11-.001-6 3 3 0 010 6zm0 7a3 3 0 11-.001-6 3 3 0 010 6zm5.173-7a.999.999 0 00.986-.835l.667-4A1.001 1.001 0 0021.82 13H21v-1h.153a.999.999 0 00.986-.835l.667-4A1.001 1.001 0 0021.82 6H21a2 2 0 00-2-2h-6a2 2 0 00-2 2h-1a1 1 0 00-.986 1.165l.666 4a1 1 0 00.987.835H11v1h-1a1 1 0 00-.986 1.165l.666 4a1 1 0 00.987.835H11v1h-1a1 1 0 00-.986 1.165l.666 4a1 1 0 00.987.835H11a2 2 0 002 2h6a2 2 0 002-2h.153a.999.999 0 00.986-.835l.667-4A1.001 1.001 0 0021.82 20H21v-1h.153z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi129;
